import { Component, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { RgActivityList } from '../../../../../../shared/interfaces/rg-activity-list.interface';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { ActivitiesTsService } from '../../../../../../services/dashboard/activities/activities.ts.service';
import { IsEditStatusTsService } from '../../../../../../services/dashboard/isEditStatus/is-edit-status.ts.service';
import { UserPreference, UserService } from '../../../../../../services/users/user.service';

@Component({
  selector: 'app-regional-access-activity-plan-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './regional-access-activity-plan-table.component.html',
  styleUrls: ['./regional-access-activity-plan-table.component.css']
})
export class RegionalAccessActivityPlanTableComponent implements OnInit {
  /*nationalActivityList: any =
    [
      {
        id: 1,
        name: "Clinical Session in Farmacia Ospedaliera",
        totalCountry: 10,
        totalCompleted: 3
      },
      {
        id: 2,
        name: "Attività di Base",
        totalCountry: 20,
        totalCompleted: 2
      },
      {
        id: 14,
        name: "Early access program",
        totalCountry: 10,
        totalCompleted: 4
      },
      {
        id: 8,
        name: "Meeting Market Access",
        totalCountry: 15,
        totalCompleted: 8
      },


    ]*/

  finalList: any = [
    {
      id: 0,
      name: "",
      totalNumber: 0,
      percentageCompletion: 0.0
    }
  ]

  public medicineId = 0;
  public countryId = 1;

  constructor (
    private dataService: DataService,
    private userPreferences: UserService,
    private activityService: ActivitiesTsService,
    private isEditService: IsEditStatusTsService
  ) { }

  ngOnInit (): void {
    this.finalList = []; // reset

    this.countryId = Number(sessionStorage.getItem('countryId')) || 1;
    this.medicineId = Number(sessionStorage.getItem('medicineId')) || 0;

    this.dataService.getRegionalActivityListStatsByMedicine(this.medicineId, this.countryId)
      .subscribe((data) => {
        this.getFinalList(data);
      });
    // console.log(this.finalList);
  }

  getFinalList (nationalActivityList: any[]): void {
    if (!Array.isArray(nationalActivityList)) {
      this.finalList = [];
      return;
    }

    this.finalList = nationalActivityList
      .map(activity => {
        const totalCountry = Number(activity.totalCountry) || 0;
        const totalCompleted = Number(activity.totalCompleted) || 0;

        // avoid division by zero
        const percentage =
          totalCountry > 0
            ? Number(((totalCompleted / totalCountry) * 100).toFixed(2))
            : 0;

        return {
          ...activity,
          percentageCompletion: percentage,
        };
      })
      // alphabetic sort by name (case-insensitive, handles missing names)
      .sort((a, b) => (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }));
  }


  /*getFinalList (nationalActivityList: any) {
    for (let i = 0; i < nationalActivityList.length; i++) {
      // we calculate the percentage 
      const percentage = parseFloat(
        ((nationalActivityList[i].totalCompleted / nationalActivityList[i].totalCountry) * 100).toFixed(2)
      );

      // we create a new object with percentage
      const activityWithPercentage = {
        ...nationalActivityList[i], // copy all original fields
        percentageCompletition: percentage // add percentage field
      };

      // we push the new object into finalList
      this.finalList.push(activityWithPercentage);
    }
    //alphabetic order
    this.finalList = this.finalList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name)
    );
  }*/

}

/*
  activityList: RgActivityList[] | undefined = [];
  selectedRows: RgActivityList[] = [];
  private destroy$ = new Subject<void>();

  public medicineId = 0;
  public countryId = 1;
  public companyId: any;
  username: string = '';
  public previousMedicineId: number = 0;
  isModalDeleteOpen: boolean = false;
  indexOfRowToDelete: number = -1;
  isEdit: boolean = false;

  selectedNames: string[] = [];
  //supportActivityList: string[] = [];
  supportActivityList: Number[] = [];

  private intervalRef: any;

  @Output() openModalAddActivities = new EventEmitter<boolean>();

  constructor (
    private dataService: DataService,
    private userPreferences: UserService,
    private activityService: ActivitiesTsService,
    private isEditService: IsEditStatusTsService
  ) { }

  ngOnInit () {
    this.countryId = Number(sessionStorage.getItem('countryId')) || 1;
    this.companyId = sessionStorage.getItem('companyId');
    this.medicineId = Number(sessionStorage.getItem('medicineId')) || 0;
    this.username = sessionStorage.getItem('username') || '';
    // flag
    let checkedThisSession = false;

    this.intervalRef = setInterval(() => {
      const currentMedicineId = Number(sessionStorage.getItem('medicineId')) || 0;
      const alreadyChecked = sessionStorage.getItem('alreadyChecked') === 'true';

      if (!alreadyChecked && !checkedThisSession) {
        checkedThisSession = true;

        this.previousMedicineId = Number(sessionStorage.getItem('previousMedicineId')) || 0;
        this.medicineId = currentMedicineId;

        if (this.medicineId === this.previousMedicineId) {
          this.supportActivityList = JSON.parse(sessionStorage.getItem('activities') || '[]');
        } else {
          this.supportActivityList = [];
          this.activityList = [];
          sessionStorage.removeItem("activities");
        }

        sessionStorage.setItem("previousMedicineId", this.medicineId.toString());
        sessionStorage.setItem("alreadyChecked", 'true');

        this.loadData();
      }
    }, 100);

    this.userPreferences.getPreferencesByUsername(sessionStorage.getItem('username') || '').subscribe({
      next: (preferences) => {
        if (preferences && preferences.relevantActivities) {
          this.activityService.setSelectedRows(preferences.relevantActivities);
        }
        this.activityService.selectedRows$
          .pipe(takeUntil(this.destroy$))
          .subscribe((rows) => {

            const selectedIds = rows;

            this.supportActivityList = Array.from(new Set([...this.supportActivityList, ...selectedIds]));
            sessionStorage.setItem('activities', JSON.stringify(this.supportActivityList));
            //sessionStorage.setItem('activities', JSON.stringify(rows));
            this.loadData();
          });
      }
    });


  }

  loadData () {
    if (!this.companyId || !this.medicineId) return;

    this.supportActivityList = JSON.parse(sessionStorage.getItem('activities') || '[]');

    this.dataService.getRegionalActivityListByMedicine(this.companyId, this.medicineId)
      .subscribe((data: RgActivityList[]) => {
        const namesToFilter = this.supportActivityList.length > 0 ? this.supportActivityList : [];

        const filtered = data
          .filter(activity => namesToFilter.includes(activity.activityId))
          .sort((a, b) => a.name.localeCompare(b.name));

        this.activityList = filtered.map(activity => ({
          ...activity,
          percentage: Math.round((activity.completion / 21) * 100),
        }));
      });
  }

  removeActivity (index: number) {
    this.indexOfRowToDelete = index;
    this.onDeleteModal();
  }

  openModalAddActivity () {
    this.openModalAddActivities.emit(true);
  }

  ngOnDestroy (): void {
    clearInterval(this.intervalRef);
    this.destroy$.next();
    this.destroy$.complete();
    sessionStorage.removeItem('alreadyChecked');
  }

  onDeleteModal () {
    this.isModalDeleteOpen = true;
  }

  closeModal () {
    this.isModalDeleteOpen = false;
  }

  onDelete () {
    if (!this.activityList) return;

    const removedActivityId = this.activityList[this.indexOfRowToDelete].activityId;
    this.activityList.splice(this.indexOfRowToDelete, 1);

    this.supportActivityList = this.supportActivityList.filter(id => id !== removedActivityId);
    sessionStorage.setItem('activities', JSON.stringify(this.supportActivityList));
    const payload = {
      username: this.username,
      companyId: this.companyId,
      relevantActivities: this.supportActivityList
    };
    this.userPreferences.updateUserPreferences(this.username, payload).subscribe({
      next: () => console.log('Preferences updated successfully'),
      error: (err) => console.error('Error updating preferences', err)
    });
    this.isModalDeleteOpen = false;
  }

  toggleEdit (value: boolean) {
    if (this.activityList?.length === 0) {
      this.isEdit = false;
    } else {
      this.isEdit = value;
    }
    this.isEditService.setEditMode(this.isEdit);
  }
}*/
